import { decodeSfList } from '@svta/cml-structured-field-values'
import type { CmsdDynamic } from './CmsdDynamic.ts'

/**
 * Decode a CMSD dynamic string to an object.
 *
 * @param cmsd - The CMSD string to decode.
 *
 * @returns The decoded CMSD object.
 *
 *
 * @beta
 */
export function decodeCmsdDynamic(cmsd: string): CmsdDynamic[] {
	if (!cmsd) {
		return []
	}

	const sfDict = decodeSfList(cmsd)

	return sfDict as CmsdDynamic[]
}
